// Le immagini arrivano con un percorso relativo al backend (/api/...): lo completa con l'indirizzo del backend.
const API_ORIGIN = (() => {
  try {
    return new URL(process.env.REACT_APP_BASE_URL).origin;
  } catch (e) {
    return "";
  }
})();

export const imgUrl = (src) => (src && src.startsWith("/") ? `${API_ORIGIN}${src}` : src);
